import BaseChartModel from './BaseChartModel';

function formatPct(value) {
    const formatted = `${(value * 100).toFixed(0)}`;

    const tmp = formatted === '-0' ? '0' : formatted;
    return tmp;
}

const defaultOptions = {
    metricColumn: 'metric',
    titleColumn: 'label',
    keyColumn: 'key',
    positiveDirection: 1,
    units: '%',
    domain: [0, 1],
    chartType: 'waffle',
    isPrimary: false
};

const overrideOptions = {
    format: formatPct,
};

export default class PopulationGrowthModel extends BaseChartModel {
    constructor(dataRecords, parent, options) {
        super(dataRecords, parent, { ...defaultOptions, ...options, ...overrideOptions });
    }

    get valueRows() {
        return this.rawDataRecords
            .filter(({ geographyCode }) => this.valueGeographyCode === geographyCode);
    }

    get compareRows() {
        return this.rawDataRecords
            .filter(({ geographyCode }) => this.comparisonGeographyCode === geographyCode);
    }

    get allGrowthValues() {
        return this.valueRows.map(({ value, ...rest }) => ({ ...rest, value, type: 'value', growthValue: value / this.valueRows[0].value }));
    }

    get allComparisonGrowthValues() {
        return this.compareRows.map(({ value, ...rest }) => ({ ...rest, value, type: 'comparison', growthValue: value / this.compareRows[0].value }));
    }

    get value() {
        return this.valueRows[this.valueRows.length - 1].value;
    }

    get comparisonValue() {
        return this.compareRows[this.compareRows.length - 1].value;
    }

    get growth() {
        return this.valueRows.length ? (this.valueRows[this.valueRows.length - 1].value / this.valueRows[0].value - 1) : 0;
    }

    get growthLabel() {
        const append = this.parent.showPDF ? 'Year Population Growth' : 'yr Growth';
        return this.valueRows.length ? `${this.valueRows[this.valueRows.length - 1][this.options.keyColumn] - this.valueRows[0][this.options.keyColumn]} ${append}` : '';
    }

    // eslint-disable-next-line class-methods-use-this
    get growthUnits() {
        return '%';
    }

    get comparisonGrowth() {
        return this.compareRows.length ? (this.compareRows[this.compareRows.length - 1].value / this.compareRows[0].value - 1) : 0;
    }

    get title() {
        return `Population in ${this.valueRows[this.valueRows.length - 1][this.options.keyColumn]}`;
    }

    formatValue(value) {
        return this.constructor.formatValue(value);
    }

    formatPct(value) {
        return this.constructor.formatPct(value);
    }

    static formatPct(value) {
        return formatPct(value);
    }

    static formatValue(value) {
        if (value < 1000000) {
            const formatter = d3.format(',');
            return formatter(value);
        }
        return `${(value / 1000000).toFixed(1)} Million`;
    }
}
